import Vue from 'vue'

Vue.filter('USPhoneNumber', (value) => {
  if(value) {
    let tempNumber = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10)
    return tempNumber
  }
})
